<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">INTRODUCTION</p>
<p class="center"><i>The mountains are calling and I must go.</i></p>
<p class="center"><i>—John Muir</i></p>
<p class="noindent1">What comes to mind when thinking of Virginia? Maybe you are a foodie and imagine peanuts, country ham and Brunswick stew. Perhaps you enjoy a glass of Virginia wine or a craft beer from one of the many breweries scattered throughout the state. Do you think of the terrible Sunday traffic on I-81? Are you a history buff who visits the many Civil War battlefields? Do you think of the Old Dominion as the “mother of presidents” or the national leader in vanity license plates?</p>
<p class="indent">For many, it is the mountains that run along Virginia’s western counties that come to mind when they think of the commonwealth—and for good reason. With their stunning vistas, hundreds of miles of hiking trails, winding mountain roads, vast stretches of protected land, gorgeous waterfalls and abundance of wildlife, it is little wonder that Virginia’s mountains are so beloved. This is not lost on the tourism industry; the commonwealth’s official tourism website uses the slogan “Virginia is for mountain lovers” and promotes the hashtag #VAoutdoors.</p>
<p class="indent">These exceedingly ancient mountains, standing hard against the skyline, hold much more than rugged beauty, unparalleled recreational activities and superb animal habitat. There is also mystery, intrigue and dark secrets in these high, lonely places.</p>
<div class="IMAGE">
<p class="image-center"><img alt="Image" src="images/P10-1.jpg"/></p>
<p class="caption">Crabtree Falls, located in the George Washington National Forest in Nelson County, is the tallest set of waterfalls in Virginia and one of the tallest east of the Mississippi River.</p>
</div>
<div class="IMAGE">
<p class="image-center"><img alt="Image" src="images/P11-1.jpg"/></p>
<p class="caption">An amazing view from a trail in the Wolf Gap Recreation Area on the Shenandoah County, Virginia and Hardy County, West Virginia border.</p>
</div>
<div class="IMAGE">
<p class="image-center"><img alt="Image" src="images/P11-2.jpg"/></p>
<p class="caption">A spectacular rock formation composed of hexagonal columnar basalt near Compton Peak in Shenandoah National Park.</p>
</div>
<div class="IMAGE">
<p class="image-center"><img alt="Image" src="images/P12-1.jpg"/></p>
<p class="caption">Cascade Falls in the Jefferson National Forest in Giles County is arguably the most beautiful waterfall in Virginia. Little Stony Creek falls over a vertical cliff, and the sixty-nine-foot falls land into a pool below.</p>
</div>
<div class="IMAGE">
<p class="image-center"><img alt="Image" src="images/P13-1.jpg"/></p>
<p class="caption">A view from atop the unique rock formation known as Dragon’s Tooth in Roanoke County. The hike to Dragon’s Tooth is challenging but rewarding.</p>
</div>
<p class="indent">The densely forested hillsides and hard-to-reach ridges conceal a resurgent mountain lion population; Bigfoot lurks here; aggressive monkeys with nasty dispositions swing through the trees and attack unsuspecting motorists; and strange flying creatures with enormous wingspans glide through the sky. And that is only for starters! An extraordinary number of UFOs crisscross Virginia airspace; nine-foot giants once ruled the land; ancient Phoenicians may have settled on isolated mountaintops; and there’s gold in them hills! For those with an open mind and a love of strange stories, these mysteries and more are waiting to be explored in Virginia’s mountains.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Introduction.vue?42686f02